import React from 'react';

import { useCliveConfigOptions } from '~/components/SystemConfiguration/CliveConfiguration/CliveConfigurationContext';

interface CliveConditionalDisplayProps {
  children: React.ReactNode;
  subOrganizationId: number | null;
  displayClive?: boolean;
}

const CliveConditionalDisplay: React.FC<CliveConditionalDisplayProps> = ({
  children,
  subOrganizationId,
  displayClive = true,
}) => {
  const { isCliveEnabled, isCliveEnabledForOrganization } = useCliveConfigOptions();

  const shouldDisplay =
    subOrganizationId !== null
      ? isCliveEnabled(subOrganizationId) && displayClive
      : isCliveEnabledForOrganization() && displayClive;

  if (!shouldDisplay) {
    return null;
  }

  return <>{children}</>;
};

export default CliveConditionalDisplay;
